import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  SessionStateService,
  WIDGET_SESSION_STORAGE_KEY,
} from '../session/session-state.service';

/**
 * Alineado con billetera-core: PUT /start-session devuelve session_id y a partir
 * de ahi todas las llamadas viajan con X-User-Session.
 */
@Injectable({ providedIn: 'root' })
export class WidgetSessionService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionStateService);

  /** Restaura la sesion anonima desde sessionStorage o la crea contra el middleware. */
  ensureSessionStarted(): Observable<string> {
    if (environment.useMock) {
      return of('');
    }

    const existing = this.session.sessionId();
    if (existing) {
      return of(existing);
    }

    const stored = sessionStorage.getItem(WIDGET_SESSION_STORAGE_KEY);
    if (stored) {
      this.session.setSessionId(stored);
      return of(stored);
    }

    return this.http
      .put<{ session_id: string; message?: string }>(
        `${environment.apiUrl}/start-session`,
        {},
      )
      .pipe(
        tap((res) => this.session.setSessionId(res.session_id)),
        map((res) => res.session_id),
        // El flujo de prestamos no depende de la sesion de core: si falla, se sigue.
        catchError(() => of('')),
      );
  }
}
